import React from 'react'
import { getBoundingClientRect } from '../../utils/functions'
import { checkTranslation, translate } from '../../utils/useful'


class TableHead extends React.Component {

    state = {

    }

    componentDidMount() {
        this.updateStickyStyles()
    }

    componentDidUpdate() {
        this.updateStickyStyles()
    }

    updateStickyStyles = () => {
        if (this['action-actions']) {
            const isRTL = document.body.classList.contains('rtl')
            // Force sticky positioning with enhanced glassy effect
            this['action-actions'].style.cssText += `position: sticky !important; z-index: 10 !important; background: linear-gradient(135deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.1) 100%) !important; background-color: rgba(255, 255, 255, 0.05) !important; overflow: visible !important; backdrop-filter: blur(20px) saturate(200%) brightness(1.1) !important; -webkit-backdrop-filter: blur(20px) saturate(200%) brightness(1.1) !important;`
            if (isRTL) {
                this['action-actions'].style.cssText += `left: 0 !important; right: auto !important;`
            } else {
                this['action-actions'].style.cssText += `right: 0 !important; left: auto !important;`
            }
        }
    }

    componentWillUnmount() {
        window.removeEventListener("mousemove", this.mouseMove)
        window.removeEventListener("mouseup", this.mouseUp)
    }

    onMouseDown = (e, key) => {
        // console.log(getBoundingClientRect(this[key]))

        this.initWidth = getBoundingClientRect(this[key]).width
        this.initLeft = getBoundingClientRect(this[key]).left

        this.setState({ selectedKey: key, initX: e.clientX })
        window.addEventListener("mousemove", this.mouseMove)
        window.addEventListener("mouseup", this.mouseUp)
    }

    mouseMove = (e) => {
        // console.log("mouse move")
        let x = e.clientX
        // console.log(x)
        // let width = getBoundingClientRect(this[this.state.selectedKey]).width

        let dx = x - this.state.initX


        // console.log(Math.abs(this.state.initX - this.initLeft))
        if (Math.abs(this.state.initX - this.initLeft) < 20) {
            dx = dx * -1
        }

        let newWidth = this.initWidth + dx

        // console.log('------')
        // console.log('x: ' +e.clientX)
        // console.log('initX: '+ this.state.initX )
        // console.log('initLeft: '+ this.initLeft )

        // console.log(dx)
        // console.log(this.initWidth)
        // console.log(newWidth)


        if (newWidth >= 100) {
            this.props.changeWidth(this.state.selectedKey, newWidth)
        }
        // console.log(width)
        // console.log(newWidth)
        // console.log(this[this.state.selectedKey].getComputedStyle())
        // console.log(getComputedStyle(this[this.state.selectedKey]))

    }



    mouseUp = (e) => {
        // console.log("mouse up")
        this.setState({ selectedKey: null })
        window.removeEventListener("mousemove", this.mouseMove)
        window.removeEventListener("mouseup", this.mouseUp)
    }

    render() {
        return (
            <div className={"flexc blur-back tableHeader " + (this.state.selectedKey ? 'isResizingTable' : '')} style={{ width: this.props.widths['*'], alignItems: 'stretch', display: 'flex', position: 'relative', minWidth: '100%' }}>
                <div className="flexcc" style={{ zIndex: 1, flex: '0 0 30px', width: '30px' }}>
                    <p style={{ color: '#789', fontSize: 12 }}>#</p>
                </div>

                {this.props.headers?.map((prop, index) => {
                    if (prop.showMain != false) {
                        let isSticky = false
                        if (index === 0 && Math.abs(this.props.scrollX) > 5) {
                            isSticky = true
                        }
                        //  if (index === 0){
                        //      console.log(isSticky)
                        //  }
                        // transform: isSticky ? 'translateX(' + this.props.scrollX + 'px)' : 'translateX(0px)',
                        return (
                            
                            <div ref={el => this[prop.key] = el} className={" tableHeaderItem blur-back " + (isSticky ? 'stickyTableHeaderItem' : '')} key={prop.key} style={{ flex: index == 0 ? '1 0' : '0 0', maxWidth: index == 0 ? null : this.props.widths[prop.key], flexBasis: this.props.widths[prop.key] }}>

                                <span className="w-100" >{checkTranslation(prop.information?.label)}</span>
                                {/* style={{whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}} */}

                                <div className={"resizer " + (this.state.selectedKey === prop.key ? 'activedResizer' : '')} onMouseDown={e => this.onMouseDown(e, prop.key)}></div>
                            </div>
                        )
                    }
                })}



                {/* {this.props.settings?.extendedActions && this.props.actions?.map((prop, index) => {
                    let isSticky = false

                    return (
                        <div ref={el => this["actions-" + prop.key] = el} className={"tableHeaderItem blur-back "} style={{ flex: '0 0', maxWidth: 120, flexBasis: 100 }}>
                            <span>{checkTranslation(prop.information?.label)}</span>
                            <div className={"resizer " + (this.state.selectedKey === prop.key ? 'activedResizer' : '')} onMouseDown={e => this.onMouseDown(e, prop.key)}></div>
                        </div>
                    )
                })} */}

                {!this.props.settings?.extendedActions && this.props.actions && Object.values(this.props.actions).length > 0 && (() => {
                    const isRTL = typeof document !== 'undefined' && document.body.classList.contains('rtl')
                    return (
                        <div ref={el => {
                            this['action-actions'] = el
                        }} className={"tableHeaderItem blur-back sticky-actions"} style={{ 
                            flex: '0 0 auto', 
                            maxWidth: this.props.widths['*actions'], 
                            flexBasis: this.props.widths['*actions'], 
                            minWidth: this.props.widths['*actions'], 
                            width: this.props.widths['*actions'],
                            position: 'sticky', 
                            [isRTL ? 'left' : 'right']: 0, 
                            zIndex: 10, 
                            background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.1) 100%)',
                            backgroundColor: 'rgba(255, 255, 255, 0.05)', 
                            backdropFilter: 'blur(20px) saturate(200%) brightness(1.1)',
                            WebkitBackdropFilter: 'blur(20px) saturate(200%) brightness(1.1)',
                            boxShadow: isRTL 
                                ? '2px 0 12px rgba(0,0,0,0.15), inset 1px 0 0 rgba(255, 255, 255, 0.5)' 
                                : '-2px 0 12px rgba(0,0,0,0.15), inset -1px 0 0 rgba(255, 255, 255, 0.5)', 
                            borderLeft: isRTL ? 'none' : '1px solid rgba(255, 255, 255, 0.3)',
                            borderRight: isRTL ? '1px solid rgba(255, 255, 255, 0.3)' : 'none',
                            marginLeft: isRTL ? '0' : 'auto',
                            marginRight: isRTL ? 'auto' : '0',
                            alignSelf: 'stretch'
                        }}>
                            <span>{translate("actions")}</span>
                            {/* <div className={"resizer " + (this.state.selectedKey === prop.key ? 'activedResizer' : '')} onMouseDown={e => this.onMouseDown(e, prop.key)}></div> */}
                        </div>
                    )
                })()}


            </div>
        )
    }

}

export default TableHead
